(function () {
  var MARKET_PREFIX_RE = /^\/[a-z]{2}-[a-z]{2}(?=\/)/i;
  var TRACKING_VERSION = 'blog_product_click_v2';
  var clickedLinks = new WeakSet();

  function normalizePath(value) {
    if (!value) return '';
    var path = String(value).trim();
    try {
      path = new URL(path, window.location.href).pathname;
    } catch (error) {
      path = path.split('?')[0].split('#')[0];
    }
    path = path.replace(MARKET_PREFIX_RE, '');
    if (path.length > 1) path = path.replace(/\/+$/, '');
    return path || '/';
  }

  function truncate(value, maxLength) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    return text.length > maxLength ? text.slice(0, maxLength - 1) + '...' : text;
  }

  function getLinkText(link) {
    var ariaLabel = link.getAttribute('aria-label');
    if (ariaLabel) return truncate(ariaLabel, 120);

    var text = link.textContent;
    if (text && text.trim()) return truncate(text, 120);

    var image = link.querySelector('img[alt]');
    return truncate(image ? image.getAttribute('alt') : '', 120);
  }

  function getProductUrl(link) {
    var targetUrl;
    try {
      targetUrl = new URL(link.href, window.location.href);
    } catch (error) {
      return null;
    }

    if (targetUrl.origin !== window.location.origin) return null;
    var targetPath = normalizePath(targetUrl.pathname);
    if (!targetPath.startsWith('/products/')) return null;

    return { url: targetUrl, path: targetPath };
  }

  function findArticleContext(link) {
    var endProduct = link.closest('[data-hirakan-end-product]');
    if (endProduct) {
      return {
        link_type: 'end_action_product',
        placement: 'end_actions',
        container: endProduct,
        revision: link.closest('[data-hirakan-end-actions]'),
      };
    }

    var productCard = link.closest('[data-hirakan-widget="product-insert"]');
    if (productCard) {
      return {
        link_type: 'inline_product_card',
        placement: 'inline_widget',
        container: productCard,
      };
    }

    var productGrid = link.closest('[data-hirakan-widget="product-grid"]');
    if (productGrid) {
      return {
        link_type: 'inline_product_grid',
        placement: 'inline_widget',
        container: productGrid,
      };
    }

    var articleBody = link.closest('[data-hirakan-article-body]');
    if (articleBody) {
      return {
        link_type: 'article_text_link',
        placement: 'article_body',
        container: articleBody,
      };
    }

    return null;
  }

  function getLinkElement(link, context) {
    if (context.link_type === 'inline_product_card' || context.link_type === 'end_action_product') {
      return 'button';
    }

    if (context.link_type === 'inline_product_grid') {
      if (link.classList && link.classList.contains('hirakan-widget__grid-title')) return 'title';
      if (link.classList && link.classList.contains('hirakan-widget__grid-button')) return 'button';
    }

    var visibleText = String(link.textContent || '').replace(/\s+/g, ' ').trim();
    if (link.querySelector('img') && !visibleText) return 'image';
    return 'text';
  }

  function getWidgetSlotId(context) {
    if (context.link_type === 'inline_product_card') {
      return context.container.getAttribute('data-product-slot-id') || '';
    }
    if (context.link_type === 'inline_product_grid') {
      return context.container.getAttribute('data-product-grid-slot-id') || '';
    }
    return '';
  }

  function getProductHandle(targetPath, context) {
    var configuredHandle = context.container.getAttribute('data-product-handle');
    if (configuredHandle) return configuredHandle;
    return targetPath.replace(/^\/products\//, '').split('/')[0] || '';
  }

  function getEligibleProductLinks() {
    return Array.from(document.querySelectorAll('a[href]')).filter(function (candidate) {
      return getProductUrl(candidate) && findArticleContext(candidate);
    });
  }

  function getLinkIndex(link) {
    return getEligibleProductLinks().indexOf(link) + 1;
  }

  function buildPayload(link, target) {
    var context = findArticleContext(link);
    if (!context) return null;

    return {
      source_page_path: normalizePath(window.location.pathname),
      source_page_location: window.location.href,
      source_page_title: document.title,
      target_page_path: target.path,
      target_page_location: target.url.href,
      link_url: target.url.href,
      link_domain: window.location.hostname,
      link_text: getLinkText(link),
      link_index: getLinkIndex(link),
      link_type: context.link_type,
      placement: context.placement,
      product_handle: getProductHandle(target.path, context),
      widget_slot_id: getWidgetSlotId(context),
      link_element: getLinkElement(link, context),
      article_revision_id: context.revision
        ? context.revision.getAttribute('data-article-revision-id') || ''
        : '',
      tracking_version: TRACKING_VERSION,
    };
  }

  function publishShopifyEvent(payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('hirakan_blog_product_click', payload);
      }
    } catch (error) {}
  }

  function publishGa4Event(payload, callback) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'blog_product_click', Object.assign({}, payload, {
          transport_type: 'beacon',
          event_callback: callback,
          event_timeout: 500,
        }));
        return true;
      }
    } catch (error) {}
    return false;
  }

  function shouldDelayNavigation(event, link) {
    return (
      event.button === 0 &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey &&
      !event.defaultPrevented &&
      (!link.target || link.target === '_self')
    );
  }

  function navigateOnce(url) {
    var didNavigate = false;
    return function () {
      if (didNavigate) return;
      didNavigate = true;
      window.location.href = url;
    };
  }

  function handleClick(event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || clickedLinks.has(link)) return;

    var target = getProductUrl(link);
    if (!target) return;

    var payload = buildPayload(link, target);
    if (!payload) return;

    clickedLinks.add(link);
    publishShopifyEvent(payload);

    if (shouldDelayNavigation(event, link)) {
      event.preventDefault();
      var navigate = navigateOnce(target.url.href);
      var sentToGa4 = publishGa4Event(payload, navigate);
      window.setTimeout(navigate, sentToGa4 ? 350 : 0);
      return;
    }

    publishGa4Event(payload);
  }

  document.addEventListener('click', handleClick, { capture: true });
})();
